<template>
  <div>
    <div class="bg_box">
      <img class="div_img" src="@/assets/image/sys/404.png" alt="" />
    </div>
    <div class="bg_detail">
      页面找不到了哟~ 点击
      <a @click="go_home" href="">返回首页</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {
    go_home() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style scoped>
.bg_detail {
  display: flex;
  justify-content: center;
  font-size: 22px;
  color: #ccc;
}

.bg_box {
  display: flex;
  justify-content: center;
}

.div_img {
  width: 25%;
  height: 25%;
}
</style>
